var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFusdtz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105px",
    height: "121px",
    viewBox: "0 0 105 121",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uA730USDtz") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-37.4999631%",
    y1: "50.0001949%",
    x2: "112.499935%",
    y2: "50.0001949%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "18.4658%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F329F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-37.4999631%",
    y1: "50.0001949%",
    x2: "112.499935%",
    y2: "50.0001949%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "18.4658%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F329F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "40.2650239 0 80.5301187 23.2469773 80.5301187 69.7408966 40.2650239 92.9877322 0 69.7408966 0 23.2469773"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uA730Tokens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uA730USDtz",
    transform: "translate(0.797678, 0.163865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.347232,31.4871635 L51.9614278,2.97433393 L2.57584899,31.487167 L2.57584899,88.5129442 L51.9614278,117.025669 L101.347232,88.5129476 L101.347232,31.4871635 Z M51.9598795,8.92022235 L96.193186,34.4600072 L96.193186,85.5360352 L51.9598795,111.07582 L7.72657297,85.5360352 L7.72657297,34.4600072 L51.9598795,8.92022235 Z",
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.923081,30 L51.9614247,0 L0,30 L0,90.0001126 L51.9614247,120 L103.923081,90.0001196 L103.923081,30 Z M51.9614308,5.94866785 L98.7713832,32.9743327 L98.7713832,87.0257757 L51.9614308,114.051338 L5.15169797,87.0257757 L5.15169797,32.9743327 L51.9614308,5.94866785 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(11.697080, 13.507835)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-4)",
    fill: "#F2F2F2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.935800, -2.112671)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.9410422,97.8819427 C75.9705003,97.8819427 97.8820844,75.9703586 97.8820844,48.9409005 C97.8820844,21.9116195 75.9705003,0 48.9410422,0 C21.9116195,0 0,21.9116195 0,48.9409005 C0,75.9703586 21.9116195,97.8819427 48.9410422,97.8819427 Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M82.7297383,71.9750861 C78.2766981,84.6137008 66.2304691,93.6717191 52.0684733,93.6717191 C37.9064547,93.6717191 25.8601288,84.6136827 21.4070487,71.9750747 L26.9668969,71.9754585 C31.1541202,81.6910986 40.8169926,88.4924134 52.0684733,88.4924134 C63.3199254,88.4924134 72.9827135,81.69112 77.1698958,71.9754748 Z M52.0684733,28.6717191 C65.9495431,28.6717191 77.7979641,37.3739876 82.4558255,49.6205804 L76.8343444,49.62064 C72.4821908,40.3053413 63.0291286,33.8510248 52.0684733,33.8510248 C41.1077901,33.8510248 31.6546472,40.3053616 27.3024515,49.6206567 L21.6809639,49.6205922 C26.3388666,37.374005 38.1873812,28.6717191 52.0684733,28.6717191 Z",
    id: "Combined-Shape",
    fill: "#505050",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8045412,49.9946371 L20.6034544,49.9946371 C19.2107591,49.9946371 18.0817949,51.4042922 18.0817949,53.143091 L18.0817949,69.2003473 C18.0817949,70.9391461 19.2107591,72.3488012 20.6034544,72.3488012 L82.8045412,72.3488012 C84.1971799,72.3488012 85.3262008,70.9391461 85.3262008,69.2003473 L85.3262008,53.143091 C85.3262008,51.4042922 84.1971799,49.9946371 82.8045412,49.9946371 Z",
    id: "Path",
    fill: "#F2F2F2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7794847,39.0366657 L55.1334026,39.3905836 L55.1307907,44.8882774 L55.5299968,44.9488618 C59.929256,45.6746594 63.081421,47.682982 63.3856393,50.7532604 L63.3856393,50.7532604 L63.4097733,51.2468341 L63.4097733,54.9597871 L63.0558554,55.313705 L57.8819292,55.313705 L57.5280113,54.9597871 L57.5280113,52.9513029 C57.5280113,51.3635132 55.3657167,50.1397789 52.4645075,50.1397789 C49.4269205,50.1397789 47.3401299,51.4203659 47.3401299,53.4991678 C47.3401299,55.2806446 48.4295729,56.323325 51.5168361,57.5816962 L51.5168361,57.5816962 L52.7699818,58.0655601 C53.2200957,58.231461 53.7031998,58.4025964 54.2210681,58.5808304 L54.2210681,58.5808304 L55.810379,59.1268435 C61.848888,61.2979108 64.6272509,63.6639704 64.6272509,68.2295858 C64.6272509,73.2313757 60.8178352,76.6223264 54.8283585,77.4574362 L55.1304036,77.4116657 L55.1334026,82.9401844 L54.7794847,83.2941023 L49.3656021,83.2941023 L49.0116842,82.9401844 L49.0115497,77.4345699 L48.5888928,77.3736937 C43.5375504,76.5327173 39.8577506,73.9995372 39.53366,70.4482364 L39.53366,70.4482364 L39.5104036,69.9340545 L39.5104036,66.6472188 L39.8643215,66.2933008 L45.0382477,66.2933008 L45.3921656,66.6472188 L45.3921656,68.655703 C45.3921656,70.752442 48.327114,72.1364858 52.0992642,72.1364858 C55.5989527,72.1364858 57.9541284,70.7266221 57.9541284,68.5339552 C57.9541284,66.4012735 56.5172123,65.3975109 52.0201985,63.7989401 L52.0201985,63.7989401 L50.5129907,63.2649069 L49.4910155,62.8780247 C43.4487309,60.5491335 40.6670074,58.1508203 40.6670074,53.5596878 C40.6670074,48.8899548 44.1061439,45.878377 49.3036517,44.9543288 L49.3036517,44.9543288 L49.0115497,45.0086095 L49.0116842,39.3905836 L49.3656021,39.0366657 L54.7794847,39.0366657 Z",
    id: "Path",
    fill: "#505050",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFusdtz);
export default __webpack_public_path__ + "static/media/fusdtz.c66850bbf1b1ec084b08c3aabc05a72a.svg";
export { ForwardRef as ReactComponent };